<template>
  <div class="tables-basic">
    <b-breadcrumb>
      <b-breadcrumb-item v-bind:href="'/app/patients/'">Patients</b-breadcrumb-item>
      <b-breadcrumb-item active>Patient Details</b-breadcrumb-item>
    </b-breadcrumb>

    <b-col lg="12">
      <b-row>
        <b-col lg="4">
          <b-card
            title="Patient Bio"
            img-src="https://picsum.photos/600/300/?image=25"
            img-alt="Patient Image"
            img-top
            class="mb-2"
          >
            <b-col style="padding:10px" class="fw-bold text-center">
              <router-link :to="{ path: '/app/patient-edit/' + item.id}">
                <b-button pill variant="outline-warning">Edit</b-button>
              </router-link>
            </b-col>
            <table class="table table-no-border">
              <tbody>
                <tr>
                  <td>Title</td>
                  <td class="fw-bold text-right">{{ item.title.name }}</td>
                </tr>
                <tr>
                  <td>Name</td>
                  <td
                    class="fw-bold text-right"
                  >{{ item.firstName + ' ' + item.middleName + ' ' + item.lastName }}</td>
                </tr>
                <tr>
                  <td>Age</td>
                  <td class="fw-bold text-right">{{ item.age + ' years' }}</td>
                </tr>
                <tr>
                  <td>Gender</td>
                  <td class="fw-bold text-right">{{item.gender.name }}</td>
                </tr>
                <tr>
                  <td>Marital Status</td>
                  <td class="fw-bold text-right">{{item.maritalStatus.name }}</td>
                </tr>
                <tr>
                  <td>Blood Group</td>
                  <td class="fw-bold text-right">{{item.bloodGroup.name }}</td>
                </tr>
              </tbody>
            </table>
          </b-card>
        </b-col>
        <b-col lg="8">
          <div>
            <b-tabs content-class="mt-3">
              <b-tab title="Bio Details" active>
                <div class="widget-padding-md w-100 h-100 text-left border rounded">
                  <h3>
                    Contacts
                    <small>Patient Contact Info</small>
                  </h3>
                  <table class="table table-no-border">
                    <tbody>
                      <tr>
                        <td>Mobile</td>
                        <td>{{item.contact.mobileNumber }}</td>
                      </tr>
                      <tr>
                        <td>Telephone Number</td>
                        <td>{{item.contact.telephoneNumber}}</td>
                      </tr>
                      <tr>
                        <td>Email</td>
                        <td>{{ item.contact.email }}</td>
                      </tr>
                      <tr>
                        <td>Physical Address</td>
                        <td>{{item.contact.physicalAddress }}</td>
                      </tr>
                      <tr>
                        <td>Residence</td>
                        <td>{{item.contact.residence }}</td>
                      </tr>
                      <tr>
                        <td>Nationality</td>
                        <td>{{item.contact.nationality }}</td>
                      </tr>
                      <tr>
                        <td>City</td>
                        <td>{{item.contact.city }}</td>
                      </tr>
                      <tr>
                        <td>Country</td>
                        <td>{{item.contact.country }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  class="widget-padding-md w-100 h-100 text-left border rounded"
                  style="margin-top:20px"
                >
                  <h3>
                    NOK
                    <small>Patient NOK Info</small>
                  </h3>
                  <table class="table table-no-border">
                    <tbody>
                      <tr>
                        <td>Nok Name</td>
                        <td>{{item.nok.firstName + ' ' + item.nok.middleName + ' ' + item.nok.lastName }}</td>
                      </tr>
                      <tr>
                        <td>Relationship</td>
                        <td>{{item.nok.relationship.name}}</td>
                      </tr>
                      <tr>
                        <td>Mobile</td>
                        <td>{{ item.nok.contact.mobileNumber }}</td>
                      </tr>
                      <tr>
                        <td>Physical Address</td>
                        <td>{{item.nok.contact.physicalAddress }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-tab>
              <b-tab title="Visits">
                <div class="table-responsive">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th>Visit No</th>
                        <th>Date</th>
                        <th>Admission</th>
                        <th>Clinic</th>
                        <th>Visit Type</th>
                        <th>Principal Member</th>
                        <th>Member ID</th>
                      </tr>
                    </thead>
                    <tr v-for="item in visits" v-bind:key="item.id">
                      <td>{{item.visitNumber}}</td>
                      <td>{{moment(new Date(item.visitDate)).format('YYYY-MM-DD') }}</td>
                      <td>{{item.admissionClass.name}}</td>
                      <td>{{item.clinicType.name}}</td>
                      <td>{{item.admission.name}}</td>
                      <td>{{item.principalMember}}</td>
                      <td>{{item.memberID}}</td>
                    </tr>
                  </table>
                </div>
              </b-tab>
              <b-tab title="New Visit">
                <b-form @submit="onSubmit">
                  <b-row>
                    <b-col lg="12">
                      <b-form-group
                        label="Visit No"
                        label-for="input-visit-no"
                        label-cols-sm="4"
                        label-cols-lg="3"
                      >
                        <b-form-input
                          id="input-visit-no"
                          v-model="visit.visitNo"
                          placeholder="Visit No"
                          disabled
                        ></b-form-input>
                      </b-form-group>

                      <b-form-group label="Admission" label-for="radio-group-admission">
                        <b-form-radio-group
                          id="radio-group-adm-class"
                          v-model="visit.admission"
                          name="admission"
                        >
                          <b-form-radio
                            v-for="admission_type in admission_types"
                            v-bind:key="admission_type.id"
                            :value="admission_type"
                          >{{admission_type.name}}</b-form-radio>
                        </b-form-radio-group>
                      </b-form-group>
                      <b-form-group
                        v-if="visit.admission.bookBed"
                        id="input-group-bed"
                        label="Bed:"
                        label-for="input-bed"
                      >
                        <b-row>
                          <b-col sm="4">
                            <b-form-select id="input-bed" v-model="visit.bed" :options="beds" />
                          </b-col>
                          <b-col sm="4">
                            <b-form-select id="input-bed" v-model="visit.bed" :options="beds" />
                          </b-col>
                          <b-col sm="4">
                            <b-form-select id="input-bed" v-model="visit.bed" :options="beds" />
                          </b-col>
                        </b-row>
                      </b-form-group>

                      <b-form-group label="Admission Class" label-for="radio-group-adm-class">
                        <b-form-radio-group
                          id="radio-group-adm-class"
                          v-model="visit.admissionClass"
                          name="admissionClass"
                        >
                          <b-form-radio
                            v-for="admission_class in admission_classes"
                            v-bind:key="admission_class.id"
                            :value="admission_class"
                          >{{admission_class.name}}</b-form-radio>
                        </b-form-radio-group>
                      </b-form-group>

                      <b-form-group
                        id="input-group-clinic-type"
                        label="Clinic Type:"
                        label-for="input-clinic-type"
                      >
                        <b-form-select
                          id="input-clinic-type"
                          v-model="visit.clinicType"
                          :options="clinics"
                        />
                      </b-form-group>

                      <b-form-group label="Billing Type" label-for="radio-group-adm-class">
                        <b-form-radio-group
                          id="radio-group-billing-type"
                          v-model="visit.billingType"
                          name="billingType"
                        >
                          <b-form-radio
                            v-for="billing_type in billing_types"
                            v-bind:key="billing_type.id"
                            :value="billing_type"
                          >{{billing_type.name}}</b-form-radio>
                        </b-form-radio-group>
                      </b-form-group>

                      <b-form-group
                        id="input-group-insuarance"
                        label="Insuarance:"
                        label-for="input-insuarance"
                        v-if="visit.billingType === '1'"
                      >
                        <b-form-select
                          id="input-insuarance"
                          v-model="visit.insuarance"
                          :options="insuarance_providers"
                        />
                      </b-form-group>

                      <b-form-group
                        label="Member ID"
                        label-for="input-member-id"
                        v-if="visit.billingType === '1'"
                      >
                        <b-form-input
                          id="input-member-id"
                          v-model="visit.memberId"
                          required
                          placeholder="Member ID"
                        ></b-form-input>
                      </b-form-group>

                      <b-form-group
                        label="Principal Member"
                        label-for="input-principal-member"
                        v-if="visit.billingType === '1'"
                      >
                        <b-form-input
                          id="input-principal-member"
                          v-model="visit.principalMember"
                          required
                          placeholder="Principal Member"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-button type="submit" variant="primary">Save</b-button>
                </b-form>
              </b-tab>
            </b-tabs>
          </div>
        </b-col>
      </b-row>
    </b-col>

    <b-modal ref="delete_modal" id="delete_modal" title="Confirm Delete" hide-footer>
      <p class="my-4">Are you sure you want to delete this record?</p>

      <b-row>
        <b-col>
          <b-button
            class="mt-3"
            pill
            variant="outline-info"
            block
            @click="$bvModal.hide('delete_modal')"
          >No</b-button>
        </b-col>
        <b-col class="text-right">
          <b-button class="mt-3" pill variant="outline-danger" block @click="onDeleteSelected">Yes</b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import Widget from "@/components/Widget/Widget";
import userApi from "@/services/userApi";
/*
import patientApi from "@/services/patientApi";
import admissionApi from "@/services/admissionApi";
import admissionClassApi from "@/services/admissionClassApi";
import billingTypeApi from "@/services/billingTypeApi";
import clinicTypeApi from "@/services/clinicTypeApi";
import insuranceApi from "@/services/insuranceApi";
import visitApi from "@/services/visitApi";
*/

export default {
  name: "Patient",
  components: { Widget },
  data() {
    return {
      clinics: [{ text: "Select One", value: "" }],
      insuarance_providers: [{ text: "Select One", value: "" }],
      beds: [{ text: "Select One", value: "" }],
      visits: [],
      visit: {
        visitNo: null,
        visitDate: new Date(),
        admission: "",
        admissionClass: { name: "" },
        bed: null,
        clinic: null,
        billingType: null,
        insuarance: null,
        memberId: "",
        principalMember: "",
        patient: {
          id: this.$route.params.id
        }
      },
      item: {
        title: "",
        age: "123",
        firstName: "",
        middleName: "",
        lastName: "",
        dob: null,
        gender: "",
        maritalStatus: "",
        bloodGroup: "",
        primaryNumber: "",
        contact: {
          mobileNumber: "",
          telephoneNumber: "",
          email: "",
          physicalAddress: "",
          postalAddress: "",
          residence: "",
          nationality: "",
          city: "",
          country: ""
        },
        existingFileNumber: "",
        nok: {
          firstName: "",
          middleName: "",
          lastName: "",
          relationship: "",
          contact: {
            mobileNumber: "",
            telephoneNumber: "",
            email: "",
            physicalAddress: "",
            postalAddress: "",
            residense: "",
            nationality: "",
            city: "",
            country: ""
          }
        }
      },
      admission_types: [],
      admission_classes: [],
      billing_types: []
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.saveItem(0, this.visit);
    },
    saveItem(id, value) {
      if (id > 0) {
        visitApi
          .update(id, value)
          .then(response => {
            this.item = response;
            this.onSaved(true, "");
          })
          .catch(error => {
            console.log(error);
            this.onSaved(false, error);
          });
      } else {
        visitApi
          .create(value)
          .then(response => {
            this.item = response;
            this.onSaved(true, "");
          })
          .catch(error => {
            console.log(error);
            this.onSaved(false, error);
          });
      }
    },
    onSaved(sucessful, error_msg) {
      if (sucessful) {
        this.$router.push("/app/patientlocation");
      } else {
        this.err_mesage = error_msg;
        this.$refs["error_modal"].show();
      }
    },
    getByID(id) {
      patientApi
        .getByID(id)
        .then(response => {
          this.item = response;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getVisits(id) {
      visitApi
        .getByPatient(id)
        .then(response => {
          this.visits = response;
        })
        .catch(error => {
          console.log(error);
        });
    },
    onDeleteSelected() {
      this.$refs["delete_modal"].hide();
      patientApi
        .deleteByID(this.$route.params.id)
        .then(response => {
          this.$router.push("/app/patients");
        })
        .catch(error => {
          console.log(error);
        });
    },
    intializeOptions() {
      admissionApi
        .getAll()
        .then(response => {
          this.admission_types = response;
        })
        .catch(error => {
          console.log(error);
        });

      admissionClassApi
        .getAll()
        .then(response => {
          this.admission_classes = response;
        })
        .catch(error => {
          console.log(error);
        });

      billingTypeApi
        .getAll()
        .then(response => {
          this.billing_types = response;
        })
        .catch(error => {
          console.log(error);
        });

      clinicTypeApi
        .getAll()
        .then(response => {
          this.updateElements(response, this.clinics);
        })
        .catch(error => {
          console.log(error);
        });

      insuranceApi
        .getAll()
        .then(response => {
          this.updateElements(response, this.insuarance_providers);
        })
        .catch(error => {
          console.log(error);
        });
    },
    updateElements(response, ui_array) {
      for (var i = 0; i < response.length; i++) {
        var obj = response[i];
        var option = {
          text: obj.name,
          value: obj
        };
        ui_array.splice(1, ui_array);
        ui_array.push(option);
      }
    }
  },
  mounted() {
    //this.getByID(this.$route.params.id);
    //this.intializeOptions();
    //this.getVisits(this.$route.params.id);
  },
  created() {
    userApi.isLoggedIn(this.$router);
  }
};
</script>

<style src="./Style.scss" lang="scss" scoped />
